<template>
	<c-dialog ref="dialog" width="560px" mask-close :button="false">
		<!-- 商品信息：改号必须先确认改的是哪一台机器，背贴码随行展示防误改 -->
		<div class="product-info">
			<p class="product-name">{{getProductText(productData)}}</p>
			<p class="info-line">背贴码：{{productData.produce_unique_code || '-'}}</p>
			<p class="info-line">当前串号：{{productData.produce_imei || '-'}}</p>
		</div>

		<div class="imei-input flex-center-cross">
			<c-input ref="imeiInput" v-model="newImei" class="flex-grow" placeholder="请扫描或输入新串号" style="height: 40px; padding: 0 8px; border-radius: 4px 0 0 4px;" @keyup.enter.native="submitHandle">
				<template #appendIcon><i class="tf-scan" style="font-size: 16px; color: #bbb;"></i></template>
			</c-input>
			<c-button color="main" style="width: 46px; height: 40px; padding: 0; border-radius: 0 4px 4px 0; font-size: 13px;" @click="submitHandle">修改</c-button>
		</div>

		<!-- 口径说明：老串号只留存最近一次，完整历史看背贴码日志 -->
		<p class="tip">修改后原串号自动留存，台账仍可按原串号搜到这台机器；完整改号记录看背贴码日志</p>
	</c-dialog>
</template>

<script>
export default {
	name: 'qualityUpdateImei',

	data() {
		return {
			// 当前行数据（列表行原样传入，只用展示字段与 product_code_id）
			productData: {},
			newImei: ''
		}
	},

	methods: {
		/*********打开弹框**********/
		open(data) {
			//弹框实例是全局复用的，每次打开都要重置行数据与输入，避免带出上一台机器的串号
			this.productData = data || {};
			this.newImei = '';
			this.$refs.dialog.open({title: '修改串号'});
			this.focusInput();
		},

		/*********聚焦输入框**********/
		focusInput() {
			this.$nextTick(() => {
				var input = this.$refs.imeiInput && this.$refs.imeiInput.$el.querySelector('input');
				if (input) input.focus();
			});
		},

		/*********获取产品信息文字**********/
		getProductText(data) {
			var parts = [];
			if (data.brand_name) parts.push(data.brand_name);
			if (data.model_name) parts.push(data.model_name);
			if (data.color_name) parts.push(data.color_name);
			if (data.memory_name) parts.push(data.memory_name);
			return parts.join(' ') || '-';
		},

		/*********提交改号**********/
		submitHandle() {
			//扫码枪即键盘输入，回车直接提交；空值先在前端拦一次，服务端仍会必校验
			var imei = this.newImei.trim();
			if (!imei) {
				this.$message({message: '请输入串号', type: 'warn'});
				return;
			}
			this.request({
				url: '/quality/update-imei',
				data: {
					product_code_id: this.productData.product_code_id,
					produce_imei: imei
				},
				loading: true,
				success: (res, msg) => {
					this.$message({message: msg, type: 'success'});
					this.$refs.dialog.close();
					this.$emit('resolve');
				},
				fail: (msg) => {
					this.$message({message: msg, type: 'warn'});
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
	/* 商品信息卡片与字号沿用 quality_upload_image.vue 的 .product-info，两弹框视觉一致；
	   弹框内边距由三块内容各自左右 16px 撑开，与 .upload-section 同一做法 */
	.product-info
		padding 14px 16px
		background #f0f4ff
		border-radius 4px
		margin 16px 16px 18px
		.product-name
			font-size 16px
			font-weight bold
			color #1890ff
			margin 0 0 8px
		.info-line
			font-size 13px
			color #333
			line-height 24px
			margin 0
	.imei-input
		margin 0 16px
		padding 0 0 6px
	.tip
		margin 10px 16px 16px
		font-size 12px
		color #999
		line-height 20px
</style>
